import React from 'react';
import { Filter } from 'lucide-react';

// Move getFilterLabel outside the component and export it
export const getFilterLabel = (filterId) => {
  const filters = [
    { id: 'all', label: 'Show All' },
    { id: 'unanswered', label: 'Unanswered' },
    { id: 'answered', label: 'Answered' },
    { id: 'dont_know', label: 'Need Help Deciding' }
  ];
  return filters.find(f => f.id === filterId)?.label || 'All Features';
};

const FeatureFilter = ({ currentFilter, onFilterChange }) => {
  const filters = [
    { id: 'all', label: 'Show All' },
    { id: 'unanswered', label: 'Unanswered' },
    { id: 'answered', label: 'Answered' },
    { id: 'dont_know', label: 'Need Help Deciding' }
  ];

  return (
    <div className="mb-6">
      {/* Filter indicator */}
      <div className="flex items-center gap-2 mb-3 text-sm text-gray-600">
        <Filter className="w-4 h-4" />
        <span>Filtered by:</span>
        <span className="font-medium">{getFilterLabel(currentFilter)}</span>
      </div>

      {/* Filter buttons */}
      <div className="flex flex-wrap gap-2">
        {filters.map(filter => (
          <button
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors
              ${currentFilter === filter.id
                ? 'bg-gray-100 text-gray-900 border-2 border-gray-300'
                : 'bg-white border border-gray-300 text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
          >
            {filter.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FeatureFilter;